import { ElementType } from 'react';
import { StyleSheet, Text } from 'react-native';
import { View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

interface LoadingWrapperProps {
  isLoading: boolean;
  loadingText?: string;
  [key: string]: any;
}

const WithLoading = (WrappedComponent: ElementType) => {
  return function WithLoadingComponent({
    isLoading,
    loadingText,
    ...props
  }: LoadingWrapperProps) {
    if (isLoading) {
      const displayText =
        loadingText &&
        typeof loadingText === 'string' &&
        loadingText.trim().length > 0
          ? loadingText
          : 'Loading...';

      return (
        <View style={styles.loadingContainer}>
          <ActivityIndicator animating={true} size="small" color={'#39BEB7'} />
          <Text style={styles.loadingText}>{displayText}</Text>
        </View>
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default WithLoading;

const styles = StyleSheet.create({
  loadingText: {
    fontFamily: 'PlusJakartaSans-Bold',
    fontSize: 16,
    lineHeight: 18,
    color: '#39BEB7',
    marginTop: 8,
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
});
